<template>
  <tr>
    <td
      v-for="(column, index) in columns"
      :key="`td-${payment.id}-${index}`"
      :class="{
        'sum-cell': isSum
      }"
      :style="`width: ${cellWidth[index]}`"
    >
      <div
        class="relative min-w-[50px] truncate overflow-x-visible"
        :style="`width: ${cellWidth[index]}`"
      >
        <PaymentRowElement
          :column="column"
          :payment="payment"
          :index-payment="indexPayment"
          :indexcolumn="index"
          :class="forceBold ? '!font-bold' : ''"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentRowElement from '@c/Dashboard/Content/Payment/components/PaymentRowElement.vue'

export default {
  name: 'PaymentRowComponent',
  components: { PaymentRowElement },
  props: {
    payment: {
      type: Object,
      required: true
    },
    indexPayment: {
      type: Number,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    cellWidth: {
      type: Object,
      required: false,
      default: () => {}
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    },
    isSum: {
      type: Boolean,
      required: false,
      default: false
    },
    forceBold: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showTasks: false
    }
  },
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata',
      auth: 'auth/getAuth'
    }),
    rowClass() {
      return (index) => {
        let baseClass = [
          'border-slate-300  dark:border-slate-500 dark:bg-slate-700 dark:text-gray-300 p-0 min-w-[50px]'
        ]

        if (!this.isLast) {
          baseClass.push('border-b')
        }

        if (this.isSum) {
          baseClass.push(
            'border-t border-slate-300 !font-bold dark:border-white dark:bg-slate-700 dark:text-gray-300 capitalize py-3'
          )
        }

        if (index === 0) {
          baseClass.push(
            'sticky left-0 whitespace-nowrap text-left font-medium z-20'
          )

          if (this.isSum) {
            baseClass.push('bg-primary-100')
          } else {
            baseClass.push('bg-white/90')
          }
        } else {
          baseClass.push(
            'justify-center whitespace-nowrap border-l text-center'
          )

          if (this.isSum) {
            baseClass.push('bg-primary-100')
          } else {
            baseClass.push('bg-white')
          }
        }

        return baseClass
      }
    }
  }
}
</script>
